/*
 * @Descripttion:盲盒商城商品订单
 * @Author: lc
 * @Date: 2021-10-25 08:33:06
 * @LastEditors: lc
 * @LastEditTime: 2025-03-25 16:42:49
 */
import axios from '../.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


// 接口请求地址
const api = '/c-api/';

const goodorder = {
    //支付订单列表
    payorderlist (params) {
        return axios.get(api + 'mangheqianggoodorder/payorderlist', { params: params })
    },
    exportpayorder (params) {
        return axios.post(api + 'mangheqianggoodorder/exportpayorder', qs.stringify(params))
    },
    //关闭
    closepayorder (params) {
        return axios.post(api + 'mangheqianggoodorder/closepayorder', qs.stringify(params))
    },
    //获取编辑信息
    detail (params) {
        return axios.get(api + 'mangheqianggoodorder/detail', { params: params })
    },
    //提货
    tihuo (params) {
        return axios.post(api + 'mangheqianggoodorder/tihuo', qs.stringify(params))
    },
    //关闭
    close (params) {
        return axios.post(api + 'mangheqianggoodorder/close', qs.stringify(params))
    },
}


// 导出接口
export default goodorder



